import { useCallback, useRef } from 'react';

type Callback<T extends unknown[]> = (...args: T) => void;

/**
 * Debounce a callback method
 */
export function useDebouncedCallback<T extends unknown[]>(
  callback: Callback<T>,
  duration: number,
): Callback<T> {
  const ref = useRef<Callback<T> | null>(null);
  const timer = useRef<number | null>(null);
  ref.current = callback;
  return useCallback(
    (...args) => {
      if (timer.current !== null) {
        window.clearTimeout(timer.current);
      }
      timer.current = window.setTimeout(() => {
        ref.current?.(...args);
      }, duration);
    },
    [duration],
  );
}
